module.exports = __webpack_public_path__ + "img/chess.203f3423.jpg";